import {inject, Injectable} from '@angular/core';
import {RecordData} from "../../../../types/records-table.types";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {HttpClient} from "@angular/common/http";
import {LineChartDataParams} from "../types/line-chart-modal.types";

@Injectable({
  providedIn: 'root'
})
export class LineChartApiService {
  private http: HttpClient = inject(HttpClient);

  public getLineChartData({ path, queryParams }: LineChartDataParams): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${path}/`, {
      params: queryParams
    });
  }
}
